import React, { useState } from "react";
import { useAuth } from "../auth";
import { Button, useToast, errorMessage } from "../ui";

export default function Login() {
  const { signIn, deniedReason, signOutNow } = useAuth();
  const { show } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch (err) {
      show(errorMessage(err), "error");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/logo.png" alt="Roja" />
        <span className="t-h1">Roja Admin</span>
        <p className="t-small text-secondary" style={{ textAlign: "center", marginTop: -8 }}>
          Sign in with your admin console account.
        </p>

        {deniedReason ? (
          <div className="col" style={{ width: "100%", gap: 12 }}>
            <p className="t-small text-danger" style={{ textAlign: "center" }}>
              {deniedReason}
            </p>
            <Button variant="secondary" fullWidth onClick={() => signOutNow()}>
              Sign in as a different account
            </Button>
          </div>
        ) : (
          <form onSubmit={submit} className="col" style={{ width: "100%", gap: 12 }}>
            <div className="field">
              <label className="field-label">Email</label>
              <input className="input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
            </div>
            <div className="field">
              <label className="field-label">Password</label>
              <input className="input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <Button type="submit" fullWidth loading={busy}>
              Sign in
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
